import axios from 'axios';

// Em produção (Docker), usa /api que é proxyado pelo nginx
// Em desenvolvimento, usa a URL completa do backend
const baseURL = process.env.REACT_APP_API_URL || 
  (process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:5000/api');

console.log('API Base URL configurada:', baseURL);
console.log('NODE_ENV:', process.env.NODE_ENV);

const api = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Interceptor para log de requisições
api.interceptors.request.use(
  (config) => {
    console.log('Requisição API:', config.method?.toUpperCase(), config.url);
    return config;
  },
  (error) => {
    console.error('Erro na requisição:', error);
    return Promise.reject(error);
  }
);

// Interceptor para log de respostas
api.interceptors.response.use(
  (response) => {
    console.log('Resposta API:', response.status, response.config.url);
    return response;
  },
  (error) => {
    console.error('Erro na resposta API:', error.response?.status, error.config?.url, error.message);
    return Promise.reject(error);
  }
);

export default api;

